<template>
    <div class="familyMembers">
        <div class="familyMembers_title">
            <div class="familyMembers_title_left">
                <span style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">家庭成员</span>
            </div>
            <div class="familyMembers_title_right">
                <el-button v-if="canEdit" size="mini" @click="addfamilyMembers">添加</el-button>
            </div>
        </div>
        <el-table :data="vo.passenger.familyMembers" border="1px" style="width: 100%" class="familyMembersList">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="certificatesName" label="称谓" align="center" width="150px">
                <template slot-scope="scope">
                    <form-item
                        ref="memberTitle"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入称谓', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '称谓', propName: 'memberTitle', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.memberTitle', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesSn" label="姓名" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="memberName"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入姓名', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '姓名', propName: 'memberName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.memberName', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesDate" label="出生年月" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="memberBirthday"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '请选择出生年月', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '出生年月', propName: 'memberBirthday', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, tbFieldName: 'memberbirthday', iconName: 'rqxzk', model: 'scope.row.memberBirthday', option: [], formTdAlign: 'text-left', weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesDate" label="身份证号码" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="memberIdCardNumber"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入身份证号码', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '身份证号码', propName: 'memberIdCardNumber', propType: 'String', textFormatter: 'card', valueMaxLength: null, valueMinLength: null, model: 'scope.row.memberIdCardNumber', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesDate" label="政治面貌" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="memberPoliticalOutlook"
                        :field="{
                            defaultValue: null,
                            elementCanEdit: '{${canEdit}}',
                            elementCssHeight: null,
                            elementCssWidth: null,
                            elementFormatter: '中共党员：中共党员\n中国预备党员：中国预备党员\n共青团员：共青团员\n群众：群众',
                            elementReadonly: 1,
                            elementType: 'select',
                            emptyMessage: '请选择政治面貌',
                            errorMessage: null,
                            isRequired: 0,
                            onClickEvent: null,
                            passenger: {},
                            propComment: '政治面貌',
                            propName: 'memberPoliticalOutlook',
                            propType: 'String',
                            textFormatter: null,
                            valueMaxLength: 50,
                            valueMinLength: null,
                            tbFieldName: 'memberpoliticaloutlook',
                            iconName: 'xialakuang',
                            model: 'scope.row.memberPoliticalOutlook',
                            option: [
                                { value: '中共党员', name: '中共党员' },
                                { name: '中国预备党员', value: '中国预备党员' },
                                { name: '共青团员', value: '共青团员' },
                                { name: '群众', value: '群众' }
                            ],
                            formTdAlign: 'text-left',
                            optionGenerateType: 0,
                            clearable: true,
                            filterable: false,
                            allowCreate: false
                        }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesDate" label="工作单位及职务" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="memberCompanyName"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入工作单位及职务', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '工作单位及职务', propName: 'memberCompanyName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.memberCompanyName', option: [], autocomplete: 'off', showWordLimit: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'FamilyMembers',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        return {
            feeTypeRules
        }
    },
    data() {
        return {
            // 通用变量
            loginUser: this.$store.getters.loginUser,
            uploadRow: {},
            uploadAttachList: [] // 当前待上传附件列表
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    updated() {},
    methods: {
        addfamilyMembers() {
            this.$http({
                method: 'POST',
                url: '/rsgl/archiveFamilyMembers/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.familyMembers.push(res.body.vo)
                }
            })
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.familyMembers = this.vo.passenger.familyMembers.filter((item) => item.id !== row.id)
        }
    }
}
</script>

<style scoped lang="scss">
.familyMembers_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: #f2f5fb;
    // border: 1px solid #e3e8ee;
    // padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}
</style>
